import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "@/pages/Home";
import BoatDetail from "@/pages/BoatDetail";
import Faq from "@/pages/Faq";
import GettingHere from "@/pages/GettingHere";
import ThingsToDo from "@/pages/ThingsToDo";
import GiftVouchers from "@/pages/GiftVouchers";

function ScrollToHashOrTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 30);
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToHashOrTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/boats/:slug" element={<BoatDetail />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/getting-here" element={<GettingHere />} />
          <Route path="/lough-ree-things-to-do" element={<ThingsToDo />} />
          <Route path="/gift-vouchers" element={<GiftVouchers />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
